import { sessionQueryKey } from "@/api";
import { refreshAuthSession } from "@/lib/auth-client";
import { resolveHomeRoute } from "@/lib/home-route";
import { queryClient } from "@/lib/query-client";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

// Depois da troca, as duas sessões precisam ser relidas: a do domínio e a do
// Better Auth, que a guarda das rotas reaproveita por até 2 minutos
// (route-session.ts). Sem forçar esta, a guarda via a flag antiga
// (mustChangePassword) e pedia a troca de novo (19/10).
export function useChangePasswordRefreshSessionQuery() {
  return useCallback(
    () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: sessionQueryKey }),
        refreshAuthSession(),
      ]),
    [],
  );
}

export function useChangePasswordHomeDestination() {
  return useCallback(() => resolveHomeRoute(queryClient), []);
}

export function useGoogleCallbackHomeDestination() {
  const qc = useQueryClient();
  return useCallback(() => resolveHomeRoute(qc), [qc]);
}

export function useLoginHomeDestination() {
  const qc = useQueryClient();
  return useCallback(() => resolveHomeRoute(qc), [qc]);
}

export function useSessionGuardClearSession() {
  return useCallback(() => queryClient.clear(), []);
}

export function useSecurityRefreshSessionQuery() {
  return useCallback(() => queryClient.invalidateQueries({ queryKey: sessionQueryKey }), []);
}

export function useNoAccessClearSession() {
  const qc = useQueryClient();
  return useCallback(() => qc.clear(), [qc]);
}

export function useNoAccessHomeDestination() {
  const qc = useQueryClient();
  return useCallback(() => resolveHomeRoute(qc), [qc]);
}
